import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { globals } from './globals';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.css']

})

export class SocialMediaComponent  {
  constructor(private _router: Router ) {}

  public getTheUrl()
  {
//    console.log("SocialMediaComponent theUrl=" + globals.LOCALHOST + this._router.url);
    return globals.LOCALHOST + this._router.url;
  }
}
